import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import './SupportCard.css';
import RichTextEditor from '../RichTextEditor';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import TextEditor from '../TextEditor';
import { useForm } from 'react-hook-form';
import { getProfileLink } from '../../helper';
import moment from 'moment';
import Preloader from '../../Preloader/Preloader';
import { useAuthContext } from '../../../context/AuthContextProvider';

function SupportDetail() {
  const { state } = useLocation();
  const server = process.env.REACT_APP_SUPPORT_SERVER_URL;

  const { register, handleSubmit, errors, setError } = useForm();

  let [editorState, setEditorState] = useState('');
  const [replies, setReplies] = useState([]);
  const [loading, setLoading] = useState(true);

  const getSupportReplies = async () => {
    await axios({
      method: 'get',
      url: `${server}/api/v1/support/tickets/${state.id}/get-ticket-reply/`,
      headers: {
        Authorization: `JWT ${localStorage.getItem('token')}`,
        ApiKey: `Token ${process.env.REACT_APP_SUPPORT_API_KEY}`,
      },
    })
      .then((res) => {
        setReplies(res.data.replies);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getSupportReplies();
  }, []);

  const addReply = (data) => {
    let formData = new FormData();
    formData.append('message', editorState);
    if (data.attachments) {
      for (let i = 0; i < data.attachments.length; i++) {
        formData.append('attachments', data.attachments[i]);
      }
    }

    if (data) {
      axios({
        method: 'post',
        url: `${server}/api/v1/support/tickets/${state.id}/ticket-reply/`,
        data: formData,
        headers: {
          Authorization: `JWT ${localStorage.getItem('token')}`,
          ApiKey: `Token ${process.env.REACT_APP_SUPPORT_API_KEY}`,
        },
      }).then((res) => {
        getSupportReplies();
      });
    }
  };

  const {
    id,
    status,
    title,
    description,
    attachments,
    category: { name },
    ticket_id,
    priority,
  } = state;

  console.log(state);

  const handleDiscussion = (data) => {
    if (editorState === '') {
      setError('description', 'required', 'Field is required');
    } else {
      data.question = editorState;
      addReply(data);
    }
  };

  return (
    <>
      {!loading ? (
        <div className="ticket-container">
          <div className="ticket-card">
            <div className="ticket-header">
              <span className="ticket-id">#TCK-{ticket_id}</span>
              <div className="d-flex" style={{ gap: '10px' }}>
                <span className="status">{name}</span>
                <span
                  className="status"
                  style={
                    status === 'open'
                      ? { background: '#06bc21eb' }
                      : status === 'in_progress'
                      ? { background: '#f5b83b' }
                      : { background: '#f52b2b' }
                  }
                >
                  {status}
                </span>
              </div>
            </div>
            <div className="ticket-title">{title}</div>
            <div className="ticket-body">
              <ReactMarkdown className="d-markdown" source={description} escapeHtml={false} />
            </div>
            <div className="ticket-footer">
              <span className="priority">{priority}</span>
            </div>
            {attachments && attachments.length > 0 && (
              <div className="attachments">
                <h6>{attachments.length} Attachments</h6>
                <div className="attachment-list">
                  {attachments &&
                    attachments.length &&
                    attachments.map((attachment) => (
                      <img src={attachment.file} alt="Attachment" key={attachment.id} className="attachment-image" />
                    ))}
                </div>
              </div>
            )}
            {replies &&
              replies.length > 0 &&
              replies.map((a) => {
                return <DiscussionAnswer key={a.id} reply={a} />;
              })}
            <form className="q-form border-top mt-2" onSubmit={handleSubmit(handleDiscussion)}>
              <div className="my-2">
                <label htmlFor="message">Message</label>
                {/* <TextEditor
                editorState={editorState}
                handleChange={(e) => setEditorState(e)}
                register={register({
                  required: 'This field is required.',
                  maxLength: {
                    value: 200,
                    message: 'Field should not be at more than 200 characters.',
                  },
                })}
              /> */}
                <textarea
                  ref={register({
                    required: 'This field is required.',
                    maxLength: {
                      value: 200,
                      message: 'Field should not be at more than 200 characters.',
                    },
                  })}
                  className="form-control"
                  name="message"
                  id="message"
                  rows="3"
                  onChange={(e) => setEditorState(e.target.value)}
                  value={editorState}
                  placeholder="Write your message here..."
                ></textarea>
                <div className="text-danger ml-2 small">{errors.message && errors.message.message}</div>
              </div>
              <div className="mb-2">
                <label htmlFor="attachments">Attach a file</label>
                <input
                  ref={register}
                  multiple
                  type="file"
                  name="attachments"
                  className="form-control-file"
                  id="attachments"
                />
                <small className="text-muted">You can attach a file if you want.</small>
              </div>
              <div className="btn-action col-md-offset-5">
                <div className="form-group mt-2" align="center">
                  <input
                    type="button"
                    name="btnAction"
                    onClick={handleSubmit(handleDiscussion)}
                    defaultValue="Submit Reply"
                    className="btn btn-success"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <Preloader />
      )}
    </>
  );
}

function DiscussionAnswer({ reply }) {
  const { currentUser } = useAuthContext();
  let { message, attachments, created_at, is_support_reply, user } = reply;

  return (
    <div className="border-top">
      <div className="d-flex align-items-center pt-2 pb-1 mt-2 comment-author">
        <img alt="" src={getProfileLink()} className="img-circle mr-1 d-inline-block" />
        <div className="d-inline-block mt-2">
          <p className="mb-0 small d-block">{is_support_reply ? user : currentUser.first_name}</p>
          <p className="small text-muted mb-1 mb-0 d-block p-0">{moment(created_at).fromNow()}</p>
        </div>
      </div>
      <p className="my-2">{message}</p>
      {attachments && attachments.length > 0 && (
        <div className="attachment-list">
          {attachments &&
            attachments.length &&
            attachments.map((attachment) => (
              <img src={attachment.file} alt="Attachment" key={attachment.id} className="attachment-image" />
            ))}
        </div>
      )}
    </div>
  );
}

export default SupportDetail;
